namespace GeniuzPOS.InitialData {
    export interface PsCorperateMessageRecieptRow {
        Id?: number;
        Status?: number;
        StartDate?: string;
        EndDate?: string;
        TimeFg?: TimeFg;
        StartTime?: string;
        EndTime?: string;
        Desc?: string;
        Image?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        UpdateDate?: string;
        ActiveBy?: string;
        Activedate?: string;
        FontSize?: number;
        TextAlign?: number;
    }

    export namespace PsCorperateMessageRecieptRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'InitialData.PsCorperateMessageReciept';
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:CorperateMessage:Modify';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:CorperateMessage:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:CorperateMessage:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:CorperateMessage:Modify';

        export declare const enum Fields {
            Id = "Id",
            Status = "Status",
            StartDate = "StartDate",
            EndDate = "EndDate",
            TimeFg = "TimeFg",
            StartTime = "StartTime",
            EndTime = "EndTime",
            Desc = "Desc",
            Image = "Image",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            UpdateDate = "UpdateDate",
            ActiveBy = "ActiveBy",
            Activedate = "Activedate",
            FontSize = "FontSize",
            TextAlign = "TextAlign"
        }
    }
}
